import { render, staticRenderFns } from "./FeatureEdit.vue?vue&type=template&id=430db96d&scoped=true"
import script from "./FeatureEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430db96d",
  null
  
)

export default component.exports